import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { Subject } from 'rxjs';

import { LocalStorageService } from './localStorage.service';

@Injectable()
export class ThemeIconService {
  themeInfo: Subject<any> = new Subject();
  private renderer: Renderer2;

  constructor(private localStorageService: LocalStorageService, rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.getDefaultSetting();
  }

  themeUpdatedData(message: string) {
    this.themeInfo.next(message);
  }

  switchThemeMode(theme: string) {
    theme = theme == 'light' ? 'dark' : 'light';
    const themeClass = theme === 'dark' ? 'theme-dark-mode' : 'theme-light-mode';
    this.renderer.removeClass(document.body, theme === 'dark' ? 'theme-light-mode' : 'theme-dark-mode');
    this.renderer.addClass(document.body, themeClass);
    this.localStorageService.setItem('colorSchema', theme);
    this.updateImage(theme);
    document.documentElement.setAttribute('data-theme', theme);
    if (window['APIMaticDevPortal'] && window['APIMaticDevPortal']['setThemeMode']) {
      window['APIMaticDevPortal'].setThemeMode(theme);
    }
    this.themeUpdatedData(theme);
    return theme;
  }
  updateImage(theme) {
    const masthead = document.querySelector('masthead-secondary') || document.querySelector('secondary-masthead');
    if (masthead) {
      const img = masthead.querySelector('img');
      if (img) {
        let imgSrc = img.getAttribute('src');
        if (imgSrc) {
          if (theme === 'light') {
            imgSrc = imgSrc.replace('dark', theme);
          }
          if (theme === 'dark') {
            imgSrc = imgSrc.replace('light', theme);
          }
        }
        img.setAttribute('src', imgSrc);
      }
    }
  }

  getDefaultSetting() {
    let theme = this.localStorageService.getItem('colorSchema');
    if (!theme) {
      const legacyTheme = this.localStorageService.getItem('theme');
      if (legacyTheme) {
        theme = legacyTheme;
        this.localStorageService.setItem('colorSchema', legacyTheme);
        this.localStorageService.removeItem('theme');
      }
    }
    theme = theme ?? 'light';
    document.documentElement.setAttribute('data-theme', theme);
    const themeClass = theme === 'dark' ? 'theme-dark-mode' : 'theme-light-mode';
    this.renderer.removeClass(document.body, theme === 'dark' ? 'theme-light-mode' : 'theme-dark-mode');
    this.renderer.addClass(document.body, themeClass);
    return theme;
  }
}
